var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.6667,
    y: 4.16663,
    width: 6.66667,
    height: 11.6667,
    rx: 1,
    fill: "#00CC52"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.90126C2.5 5.07424 2.5 4.66072 2.74455 4.37876C2.98909 4.0968 3.39845 4.03832 4.21716 3.92136L11.8838 2.82612C12.946 2.67438 13.4771 2.59851 13.8219 2.89756C14.1667 3.1966 14.1667 3.73307 14.1667 4.80602V15.194C14.1667 16.2669 14.1667 16.8034 13.8219 17.1024C13.4771 17.4015 12.946 17.3256 11.8838 17.1739L4.21716 16.0786C3.39845 15.9617 2.98909 15.9032 2.74455 15.6212C2.5 15.3393 2.5 14.9258 2.5 14.0987V5.90126Z",
    fill: "#00AA44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28893 12.2442L8.28226 10.6775L7.36893 12.2442H6.31559L7.78226 9.89749L6.29559 7.59082H7.36893L8.37559 9.15082L9.28226 7.59082H10.3356L8.87559 9.93082L10.3623 12.2442H9.28893Z",
    fill: "#E5FFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExcel);
export default __webpack_public_path__ + "static/media/icon-excel.78539d471a7f6153b6e307e8314ca08e.svg";
export { ForwardRef as ReactComponent };